import { axiosInstance } from "../../../axios/axiosInstance";

const API_PUSH_NOTIFICATION_URL = "organization/push-notifications/";
const API_SEND_PUSH_NOTIFICATION_URL = API_PUSH_NOTIFICATION_URL + "send-push";
const API_GET_PUSH_NOTIFICATION_URL = API_PUSH_NOTIFICATION_URL + "active_push_notifications";
const API_GET_SENT_PUSH_NOTIFICATION_URL = API_PUSH_NOTIFICATION_URL + "push-messages-history";

export const sendOrganizationPushNotification = ({_id,...rest}) => {
  return axiosInstance.post(`${API_SEND_PUSH_NOTIFICATION_URL}/${_id}`, rest);
};
export const getOrganizationPushNotification = () => {
  return axiosInstance.get(API_GET_PUSH_NOTIFICATION_URL);
};

export const getSentOrganizationPushNotificationList = (dataToBeSent) => {
  return axiosInstance.get(`${API_GET_SENT_PUSH_NOTIFICATION_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};
